'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _layout = require('antd/lib/layout');

var _layout2 = _interopRequireDefault(_layout);

var _menu = require('antd/lib/menu');

var _menu2 = _interopRequireDefault(_menu);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HTTP_PATTERN = /^https?:\/\//;

var bubbleSort = function bubbleSort(arr, sortCb) {
  var len = arr.length;
  for (var i = 0; i < len; i++) {
    for (var j = 0; j < len - 1 - i; j++) {
      // 相邻元素两两对比
      if (sortCb(arr[j], arr[j + 1]) > 0) {
        // 元素交换
        var temp = arr[j + 1];
        arr[j + 1] = arr[j];
        arr[j] = temp;
      }
    }
  }
  return arr;
};

var Sider = exports.Sider = (_temp = _class = function (_React$PureComponent) {
  _inherits(Sider, _React$PureComponent);

  function Sider(props) {
    _classCallCheck(this, Sider);

    var _this = _possibleConstructorReturn(this, (Sider.__proto__ || Object.getPrototypeOf(Sider)).call(this, props));

    var route = props.route;
    var routes = _this.getRoutes(props.routes, props.orderKeys);
    var openKeys = route && _this.getParentsResolvePaths(route);
    if (!openKeys || !openKeys.length) {
      openKeys = _this.getOpenKeys(routes, props.subMenus);
    }
    _this.state = {
      routes: routes,
      selectedKeys: route ? [_this.props.getResolvePath(route)] : null,
      openKeys: openKeys,
      subMenus: props.subMenus
    };
    return _this;
  }

  _createClass(Sider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.route !== nextProps.route) {
        var resolvePath = this.props.getResolvePath(nextProps.route);
        if (!this.state.selectedKeys || this.state.selectedKeys.indexOf(resolvePath) === -1) {
          var routes = this.getRoutes(nextProps.routes, nextProps.orderKeys);
          var openKeys = this.state.openKeys.length ? this.state.openKeys : nextProps.route && this.getParentsResolvePaths(nextProps.route);
          if (!openKeys || !openKeys.length) {
            openKeys = this.getOpenKeys(routes, nextProps.subMenus);
          }
          this.setState({
            routes: routes,
            selectedKeys: [resolvePath],
            openKeys: openKeys
          });
        }
      }
    }
  }, {
    key: 'getRoutes',
    value: function getRoutes(routes, orderKeys) {
      if (orderKeys) {
        var map = {};
        orderKeys.forEach(function (v, index) {
          return map[v] = index;
        });
        return bubbleSort(routes, function (a, b) {
          var aName = a.children ? a.name : a.navKey || a.name;
          var bName = b.children ? b.name : b.navKey || b.name;
          var compare = map[aName] - map[bName];
          if (compare === 0 || isNaN(compare)) {
            return a.value - b.value;
          } else {
            return compare;
          }
        });
      } else {
        return routes;
      }
    }
  }, {
    key: 'getOpenKeys',
    value: function getOpenKeys(routes, subMenus) {
      var _this2 = this;

      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (this.props.openLevel) {
        var cacheMap = {};
        var keys = [];
        routes.forEach(function (route) {
          var children = route.children || route.childRoutes;
          if (route.navKey && subMenus[route.navKey]) {
            if (!cacheMap[route.navKey]) {
              cacheMap[route.navKey] = true;
              keys.push(route.navKey);
            }
          } else if (children && level < _this2.props.openLevel) {
            if (!cacheMap[route.name]) {
              cacheMap[route.name] = true;
              keys.push(route.name);
            }
            keys = keys.concat(_this2.getOpenKeys(children, subMenus, level + 1));
          }
        });
        return keys;
      } else {
        return null;
      }
    }
  }, {
    key: 'getParentsResolvePaths',
    value: function getParentsResolvePaths(route) {
      var resolvePaths = [];
      var navKey = route.navKey;
      while (route.parent) {
        route = route.parent;
        resolvePaths.push(route.name);
      }
      if (navKey && this.props.subMenus[navKey]) {
        resolvePaths.push(navKey);
      }
      return resolvePaths;
    }
  }, {
    key: 'packNode',
    value: function packNode(item, level) {
      var _this3 = this;

      var subMenus = this.state.subMenus;
      if (item.hide || item.disabled) {
        return null;
      }
      if (item.navKey && subMenus[item.navKey]) {
        if (subMenus[item.navKey].hide || subMenus[item.navKey].disabled) {
          return null;
        }
        if (level < 1) {
          subMenus[item.navKey].children = subMenus[item.navKey].children || [];
          var idx = subMenus[item.navKey].children.findIndex(function (d) {
            return d.name === item.name;
          });
          if (idx === 0) {
            item = subMenus[item.navKey];
          } else if (idx === -1) {
            subMenus[item.navKey].children = subMenus[item.navKey].children || [];
            idx = subMenus[item.navKey].children.push(item);
            if (idx > 1) {
              clearTimeout(this._timer);
              this._timer = setTimeout(function () {
                clearTimeout(_this3._timer);
                if (_this3.mounted) {
                  _this3.forceUpdate();
                }
              });
              return null;
            } else {
              var navKey = item.navKey;
              item = subMenus[item.navKey];
              item.name = navKey;
            }
          } else {
            return null;
          }
        }
      }

      // #! 从路由配置项中获取childRoutes
      var target = item.target;
      var title = item.title || item.name;
      var icon = item.icon;
      var iconCom = icon && _react2.default.createElement(_icon2.default, { type: icon });
      var children = item.children || item.childRoutes || [];

      if (title) {
        return {
          target: target,
          icon: iconCom,
          title: title,
          name: item.navKey ? item.navKey + '-' + item.name : item.name,
          children: children,
          hide: item.hide || item.disabled,
          path: children.length ? null : this.props.getResolvePath(item)
        };
      } else {
        return null;
      }
    }
  }, {
    key: 'getNavMenuItems',
    value: function getNavMenuItems(menusData) {
      var _this4 = this;

      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var ILink = this.props.Link;
      if (!menusData) {
        return [];
      }
      return menusData.map(function (item) {
        item = _this4.packNode(item, level);

        if (!item) {
          return null;
        }

        if (item.children.length) {
          return _react2.default.createElement(
            _menu2.default.SubMenu,
            {
              title: item.icon ? _react2.default.createElement(
                'span',
                null,
                item.icon,
                _react2.default.createElement(
                  'span',
                  { className: 'j-menu-text' },
                  item.title
                )
              ) : _react2.default.createElement(
                'span',
                { className: 'j-menu-text' },
                item.title
              ),
              key: item.name },
            _this4.getNavMenuItems(item.children, level + 1)
          );
        }
        return _react2.default.createElement(
          _menu2.default.Item,
          { key: item.path },
          HTTP_PATTERN.test(item.path) ? _react2.default.createElement(
            'a',
            {
              href: item.path,
              target: item.target,
              onClick: function onClick(e) {
                return ['_self', undefined].indexOf(item.target) === -1 && e.stopPropagation();
              } },
            item.icon,
            _react2.default.createElement(
              'span',
              { className: 'j-menu-text' },
              item.title
            )
          ) : _react2.default.createElement(
            ILink,
            { to: item.path, target: item.target },
            item.icon,
            _react2.default.createElement(
              'span',
              { className: 'j-menu-text' },
              item.title
            )
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var Conn = void 0;
      var connProps = void 0;
      var sider = this.props.sider;
      var header = this.props.header;
      var brand = this.props.brand;
      var ILink = this.props.Link;
      var flexDiv = void 0;

      var menuOption = Object.assign({
        mode: 'inline',
        theme: 'dark',
        inlineIndent: 24
      }, this.props.menu);

      if (menuOption.mode === 'horizontal') {
        Conn = _layout2.default.Header;
        connProps = header || {};
      } else {
        menuOption.style = menuOption.style || {
          margin: '16px 0',
          width: '100%'
        };
        menuOption.openKeys = this.state.collapsed ? null : this.state.openKeys;
        var _props = this.props,
            collapsed = _props.collapsed,
            onCollapse = _props.onCollapse,
            flex = _props.flex;

        Conn = _layout2.default.Sider;
        // inspired
        if (sider) {
          connProps = sider;
        } else {
          var width = this.props.width || 256;
          var collapsedWidth = this.props.collapsedWidth || 80;
          if (collapsed) {
            width = 0;
            collapsedWidth = 0;
          }
          connProps = {
            trigger: null,
            collapsible: true,
            breakpoint: 'md',
            width: width,
            collapsedWidth: collapsedWidth
          };
        }
        connProps.className = 'j-com-sider ' + 'j-com-sider-' + menuOption.theme + ' ' + (collapsed ? 'j-com-sider-collapse' : 'j-com-sider-expand');
        if (connProps.flex || flex) {
          flexDiv = _react2.default.createElement(
            'div',
            { className: 'j-sider-collapse-outer' },
            _react2.default.createElement(
              'div',
              { className: 'j-sider-collapse-inner' },
              _react2.default.createElement('div', { className: 'j-sider-collapse-bg' }),
              _react2.default.createElement(
                'div',
                { className: 'j-sider-collapse', onClick: function onClick() {
                    return onCollapse(!collapsed);
                  } },
                collapsed ? _react2.default.createElement(_icon2.default, { type: 'menu-unfold' }) : _react2.default.createElement(_icon2.default, { type: 'menu-fold' })
              )
            )
          );
        }
      }
      return _react2.default.createElement(
        Conn,
        connProps,
        brand ? _react2.default.createElement(
          'div',
          { className: 'j-sider-logo' },
          _react2.default.createElement(
            ILink,
            { to: brand.path || '/' },
            _react2.default.createElement('img', { src: brand.logo, alt: 'logo' }),
            _react2.default.createElement(
              'h1',
              { className: 'j-menu-text' },
              brand.title
            )
          )
        ) : null,
        _react2.default.createElement(
          _menu2.default,
          _extends({
            onOpenChange: function onOpenChange(openKeys) {
              return _this5.setState({ openKeys: openKeys });
            },
            onSelect: function onSelect(item) {
              return _this5.setState({ selectedKeys: item.selectedKeys });
            },
            selectedKeys: this.state.selectedKeys,
            inlineCollapsed: this.state.collapsed
          }, menuOption),
          this.getNavMenuItems(this.state.routes)
        ),
        flexDiv
      );
    }
  }]);

  return Sider;
}(_react2.default.PureComponent), _class.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  route: _propTypes2.default.object,
  orderKeys: _propTypes2.default.array,
  collapsed: _propTypes2.default.bool,
  openLevel: _propTypes2.default.number,
  brand: _propTypes2.default.object,
  subMenus: _propTypes2.default.object,
  Link: _propTypes2.default.any,
  getResolvePath: _propTypes2.default.func,
  menu: _propTypes2.default.object,

  width: _propTypes2.default.any,
  collapsedWidth: _propTypes2.default.any,
  onCollapse: _propTypes2.default.func,
  flex: _propTypes2.default.bool,
  sider: _propTypes2.default.object,
  header: _propTypes2.default.object
}, _class.defaultProps = {
  subMenus: {},
  getResolvePath: function getResolvePath(item) {
    return item.resolvePath || item.path;
  },
  Link: _reactRouter.Link,
  brand: {
    logo: '//img.alicdn.com/tfs/TB14dINRpXXXXcyXXXXXXXXXXXX-64-64.png?t=1517996107967',
    title: 'App'
  }
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/components/sider/index.jsx
// module id = 24
// module chunks = 0